module.exports = __webpack_public_path__ + "static/media/computadorescirculares-problema.c5f0c6d8.png";